export const FETCH_EMPLOYEES = 'employees/FETCH_EMPLOYEES';
export const FETCH_ARCHIVED_EMPLOYEES = 'employees/FETCH_ARCHIVED_EMPLOYEES';
export const FETCH_EMPLOYEES_BY_ROLE = 'employees/FETCH_EMPLOYEES_BY_ROLE';
export const FETCH_USER = 'employees/FETCH_USER';

export const ADD_EMPLOYEE = 'employees/ADD_EMPLOYEE';
export const EDIT_EMPLOYEE_EMAIL = 'employees/EDIT_EMPLOYEE_EMAIL';
export const EDIT_EMPLOYEE_PASSWORD = 'employees/EDIT_EMPLOYEE_PASSWORD';
export const EDIT_EMPLOYEE_FIRSTNAME = 'employees/EDIT_EMPLOYEE_FIRSTNAME';
export const EDIT_EMPLOYEE_LASTNAME = 'employees/EDIT_EMPLOYEE_LASTNAME';
export const EDIT_EMPLOYEE_COORDINATOR = 'employees/EDIT_EMPLOYEE_COORDINATOR';
export const EDIT_EMPLOYEE_TRACK_JIRA = 'employees/EDIT_EMPLOYEE_TRACK_JIRA';
export const EDIT_EMPLOYEE_VACATION_DAYS = 'employees/EDIT_EMPLOYEE_VACATION_DAYS';
export const EDIT_EMPLOYEE_SKYPE = 'employees/EDIT_EMPLOYEE_SKYPE';
export const EDIT_EMPLOYEE_TELEGRAM = 'employees/EDIT_EMPLOYEE_TELEGRAM';
export const EDIT_EMPLOYEE_ROCKETCHAT = 'employees/EDIT_EMPLOYEE_ROCKETCHAT';
export const EDIT_EMPLOYEE_CONTACT_EMAIL = 'employees/EDIT_EMPLOYEE_CONTACT_EMAIL';
export const EDIT_EMPLOYEE_ENGLISH = 'employees/EDIT_EMPLOYEE_ENGLISH';
export const EDIT_EMPLOYEE_POSITION = 'employees/EDIT_EMPLOYEE_POSITION';
export const EDIT_EMPLOYEE_SCHEDULE = 'employees/EDIT_EMPLOYEE_SCHEDULE';
export const EDIT_EMPLOYEE_PHOTOURL = 'employees/EDIT_EMPLOYEE_PHOTOURL';
export const EDIT_EMPLOYEE_EDIT_PHONE = 'employees/EDIT_EMPLOYEE_EDIT_PHONE';
export const EDIT_EMPLOYEE_ADD_PHONE = 'employees/EDIT_EMPLOYEE_ADD_PHONE';
export const EDIT_EMPLOYEE_REMOVE_PHONE = 'employees/EDIT_EMPLOYEE_REMOVE_PHONE';
export const EDIT_EMPLOYEE_EDIT_POSITION = 'employees/EDIT_EMPLOYEE_EDIT_POSITION';
export const EDIT_EMPLOYEE_ADD_POSITION = 'employees/EDIT_EMPLOYEE_ADD_POSITION';
export const EDIT_EMPLOYEE_REMOVE_POSITION = 'employees/EDIT_EMPLOYEE_REMOVE_POSITION';
export const EDIT_EMPLOYEE_ADD_BENEFIT = 'employees/EDIT_EMPLOYEE_ADD_BENEFIT';
export const EDIT_EMPLOYEE_ADD_FACILITY = 'employees/EDIT_EMPLOYEE_ADD_FACILITY';
export const EDIT_EMPLOYEE_FACILITY_DEVICE_CHANGE = 'employees/EDIT_EMPLOYEE_FACILITY_DEVICE_CHANGE';
export const EDIT_EMPLOYEE_FACILITY_TYPE_CHANGE = 'employees/EDIT_EMPLOYEE_FACILITY_TYPE_CHANGE';
export const EDIT_EMPLOYEE_FACILITY_NUMBER_CHANGE = 'employees/EDIT_EMPLOYEE_FACILITY_NUMBER_CHANGE';
export const EDIT_EMPLOYEE_BENEFIT_CHANGE = 'employees/EDIT_EMPLOYEE_BENEFIT_CHANGE';
export const EDIT_EMPLOYEE_REMOVE_FACILITY = 'employees/EDIT_EMPLOYEE_REMOVE_FACILITY';
export const EDIT_EMPLOYEE_REMOVE_BENEFIT = 'employees/EDIT_EMPLOYEE_REMOVE_BENEFIT';
export const CLEAR_EMPLOYEE_COORDINATOR = 'employees/CLEAR_EMPLOYEE_COORDINATOR';

export const SET_UPLOADING_PHOTO = 'employees/SET_UPLOADING_PHOTO';
export const VIEW_EMPLOYEE = 'employees/VIEW_EMPLOYEE';
export const DELETE_EMPLOYEE = 'employees/DELETE_EMPLOYEE';
export const ARCHIVE_EMPLOYEE = 'employees/ARCHIVE_EMPLOYEE';
export const DUPLICATE_EMPLOYEE = 'employees/DUPLICATE_EMPLOYEE';
export const ADD_NEW_EMPLOYEE = 'employees/ADD_NEW_EMPLOYEE';
export const EDIT_EMPLOYEE = 'employees/EDIT_EMPLOYEE';
export const SEARCH_EMPLOYEE = 'employees/SEARCH_EMPLOYEE';

export const FETCH_ROLES = 'employees/FETCH_ROLES';
export const DELETE_ROLE = 'employees/DELETE_ROLE';
export const EDIT_ROLE = 'employees/EDIT_ROLE';
export const TOGGLE_ROLE = 'employees/TOGGLE_ROLE';
export const TOGGLE_ADMIN_ROLE = 'employees/TOGGLE_ADMIN_ROLE';
export const MAP_ROLES = 'employees/MAP_ROLES';
export const ADD_ROLE = 'employees/ADD_ROLE';
export const SAVE_ROLE = 'employees/SAVE_ROLE';
export const CANCEL_EDIT_ROLE = 'employees/CANCEL_EDIT_ROLE';

export const FETCH_DEPARTMENTS = 'employees/FETCH_DEPARTMENTS';
export const SAVE_DEPARTMENT = 'employees/SAVE_DEPARTMENT';
export const DELETE_DEPARTMENT = 'employees/DELETE_DEPARTMENT';
export const EDIT_DEPARTMENT = 'employees/EDIT_DEPARTMENT';
export const ADD_DEPARTMENT = 'employees/ADD_DEPARTMENT';
export const CANCEL_EDIT_DEPARTMENT = 'employees/CANCEL_EDIT_DEPARTMENT';
export const TOGGLE_DEPARTMENT = 'employees/TOGGLE_DEPARTMENT';
export const MAP_DEPARTMENTS = 'employees/MAP_DEPARTMENS';

export const UPDATE_SALARY = 'employees/UPDATE_SALARY';
export const EDIT_SALARY = 'employees/EDIT_SALARY';
export const UPDATE_SALARY_AMOUNT = 'employees/UPDATE_SALARY_AMOUNT';
export const UPDATE_SALARY_CHANGE_REASON = 'employees/UPDATE_SALARY_CHANGE_REASON';
export const UPDATE_SALARY_CURRENCY = 'employees/UPDATE_SALARY_CURRENCY';
export const UPDATE_SALARY_DATE = 'employees/UPDATE_SALARY_DATE';
export const DELETE_SALARY = 'employees/DELETE_SALARY';
export const ADD_SALARY = 'employees/ADD_SALARY';

export const FETCH_CURRENCIES = 'employees/FETCH_CURRENCIES';
export const ADD_CURRENCY = 'employees/ADD_CURRENCY';
export const DELETE_CURRENCY = 'employees/DELETE_CURRENCY';
export const SAVE_CURRENCY = 'employees/SAVE_CURRENCY';
export const EDIT_CURRENCY = 'employees/EDIT_CURRENCY';
export const CANCEL_EDIT_CURRENCY = 'employees/CANCEL_EDIT_CURRENCY';

export const FETCH_FACILITY_TYPES = 'employees/FETCH_FACILITY_TYPES';
export const ADD_FACILITY_TYPE = 'employees/ADD_FACILITY_TYPE';
export const DELETE_FACILITY_TYPE = 'employees/DELETE_FACILITY_TYPE';
export const SAVE_FACILITY_TYPE = 'employees/SAVE_FACILITY_TYPE';
export const EDIT_FACILITY_TYPE = 'employees/EDIT_FACILITY_TYPE';
export const CANCEL_EDIT_FACILITY_TYPE = 'employees/CANCEL_EDIT_FACILITY_TYPE';

export const FETCH_FACILITY_DEVICES = 'employees/FETCH_FACILITY_DEVICES';
export const ADD_FACILITY_DEVICE = 'employees/ADD_FACILITY_DEVICE';
export const DELETE_FACILITY_DEVICE = 'employees/DELETE_FACILITY_DEVICE';
export const SAVE_FACILITY_DEVICE = 'employees/SAVE_FACILITY_DEVICE';
export const EDIT_FACILITY_DEVICE = 'employees/EDIT_FACILITY_DEVICE';
export const CANCEL_EDIT_FACILITY_DEVICE = 'employees/CANCEL_EDIT_FACILITY_DEVICE';

export const FETCH_BENEFITS = 'employees/FETCH_BENEFITS';
export const ADD_BENEFIT = 'employees/ADD_BENEFIT';
export const DELETE_BENEFIT = 'employees/DELETE_BENEFIT';
export const SAVE_BENEFIT = 'employees/SAVE_BENEFIT';
export const EDIT_BENEFIT = 'employees/EDIT_BENEFIT';
export const CANCEL_EDIT_BENEFIT = 'employees/CANCEL_EDIT_BENEFIT';

export const CHECK_GOOGLE_ACCOUNT = 'employees/CHECK_GOOGLE_ACCOUNT';
export const EDIT_GOOGLE_ACCOUNT_CREATION = 'employees/EDIT_GOOGLE_ACCOUNT_CREATION';



// WEBPACK FOOTER //
// ./src/store/modules/employees/mutation-types.js